import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../components/footer";
import bg from "../assets/background.png";
import Seo from '../components/Seo';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        background: `#ededed url(${bg}) center / cover no-repeat`,
        paddingTop: "140px",
      }}
    >
      <Seo title="Nie znaleziono strony" path="" noindex />
      <section
        style={{
          width: "92%",
          maxWidth: "700px",
          backgroundColor: "rgba(255,255,255,0.94)",
          border: "1px solid rgba(0,0,0,0.08)",
          borderRadius: "22px",
          padding: "34px 28px",
          boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
          marginBottom: "80px",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: "30px",
            fontWeight: 900,
            color: "rgba(0,0,0,0.92)",
          }}
        >
          Nie znaleźliśmy tej strony
        </h1>

        <p
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: 600,
            color: "rgba(0,0,0,0.65)",
            lineHeight: 1.6,
          }}
        >
          Adres mógł się zmienić albo strona została przeniesiona. Poniżej
          znajdziesz najczęściej odwiedzane miejsca.
        </p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "8px" }}>
          {[
            { to: "/lokalizacje", label: "Nasze lokalizacje" },
            { to: "/kadra", label: "Kadra" },
            { to: "/urodziny", label: "Urodziny" },
            { to: "/kontakt", label: "Kontakt" },
          ].map((x) => (
            <Link
              key={x.to}
              to={x.to}
              style={{
                textDecoration: "none",
                backgroundColor: "#d0142d",
                color: "rgb(250,250,250)",
                borderRadius: "999px",
                padding: "10px 16px",
                fontSize: "12px",
                fontWeight: 900,
              }}
            >
              {x.label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => navigate(-1)}
          style={{
            alignSelf: "flex-start",
            marginTop: "6px",
            border: "1px solid rgba(0,0,0,0.12)",
            backgroundColor: "rgba(255,255,255,0.95)",
            borderRadius: "999px",
            padding: "10px 16px",
            fontSize: "12px",
            fontWeight: 900,
            cursor: "pointer",
          }}
        >
          Wróć
        </button>
      </section>

      <Footer />
    </div>
  );
}
